var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.12229 24.8926C 2.11861 16.8757 6.27157 14.3042 9.99018 12.0258C 13.7873 9.69819 17.0716 7.65956 16.6765 1.39118e-09C 14.9072 0.126358 13.2074 0.497384 11.6123 1.08491C 11.7775 7.16378 8.85072 8.9666 6.01063 10.7074C 3.01104 12.5457 0.177505 14.2825 1.17015e-08 21.1364C 0.237219 22.441 0.614315 23.7006 1.12229 24.8926Z",
    transform: "translate(0 0.045105)",
    fill: "#E9EEF2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.9137 7.56459C 7.56074 5.94125 9.70143 4.61328 9.74969 9.21053e-09C 4.9317 2.32354 1.2998 6.67042 5.46071e-09 11.9082C 1.33415 9.76016 3.18855 8.62133 4.9137 7.56459Z",
    transform: "translate(0.231445 1.82135)",
    fill: "#E9EEF2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.07812 31.2459C 3.7227 22.7018 7.53292 19.7199 11.2278 16.833C 15.2417 13.6974 19.0348 10.726 18.8213 0.301811C 17.8258 0.119115 16.8033 0.0169014 15.7587 0C 16.1824 8.58028 12.1865 11.0575 8.30429 13.4366C 4.37137 15.8471 0.312474 18.3493 -6.08479e-08 27.6185C 0.862985 28.9569 1.89775 30.1771 3.07812 31.2459Z",
    transform: "translate(2.55078 0)",
    fill: "#E9EEF2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.2748 18.3992C 15.9411 15.5042 19.3996 12.7485 19.2147 3.14205C 18.2274 1.95815 17.0896 0.903823 15.8315 -3.07018e-08C 15.78 10.495 11.6335 13.7755 7.61472 16.9481C 3.83231 19.9348 0.261759 22.7606 6.74008e-07 31.8495C 1.50838 32.2761 3.09448 32.5183 4.73374 32.5473C 5.16483 24.0378 8.773 21.1654 12.2748 18.3992Z",
    transform: "translate(12.9458 3.4527)",
    fill: "#E9EEF2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.1681 4.32274C 2.54233 5.89698 0.265032 7.27727 1.29809e-06 12.8129C 5.03477 10.3235 8.74601 5.6169 9.80286 -2.45614e-07C 8.62331 2.24869 6.83435 3.32394 5.1681 4.32274Z",
    transform: "translate(26.1973 21.2837)",
    fill: "#E9EEF2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.1926 15.3755C 14.0049 13.6885 16.6626 12.0966 16.3387 4.69457L 16.4229 4.69135C 15.991 3.02213 15.317 1.44708 14.4466 9.21054e-08C 14.0597 8.58753 10.4425 11.472 6.92433 14.2503C 3.57628 16.8918 0.417997 19.4085 7.36416e-07 27.0978C 1.82331 26.9706 3.57301 26.5787 5.21227 25.963C 5.31207 18.9014 8.43517 17.0286 11.1926 15.3755Z",
    transform: "translate(19.3218 8.85718)",
    fill: "#E9EEF2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.3378 18.4628C 16.3583 15.2893 20.1571 12.2833 19.9346 1.71751C 18.6519 0.98833 17.2712 0.408048 15.8176 -8.05922e-09C 15.9346 10.8974 11.6973 14.2068 7.59591 17.4109C 3.86094 20.3284 0.336196 23.1002 -2.43392e-07 31.835C 1.26544 32.7501 2.6544 33.5058 4.13824 34.0797C 4.54233 24.6431 8.4998 21.493 12.3378 18.4628Z",
    transform: "translate(7.19971 0.682495)",
    fill: "#E9EEF2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dd2272a5f91326f1d124c391c7347c8d.svg";
export { ForwardRef as ReactComponent };